import {
    StyleSheet
} from "react-native";
import {
    webStyle
} from "ncore-ui-kit";

const stylesheet = StyleSheet.create({
    headerContainer: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap",
        width: "100%"
    },
    previewImageWrapper: {
        justifyContent: "center",
        alignItems: "center",
        maxHeight: 400
    },
    emptyContainer: {
        justifyContent: "center",
        alignItems: "center",
        flex: 1
    },
    itemContainer: {
        justifyContent: "center",
        position: "relative",
        alignItems: "center",
        width: "100%",
        height: 200
    },
    modalOverlay: {
        justifyContent: "center",
        alignItems: "center",
        flex: 1
    },
    closeButton: {
        justifyContent: "center",
        alignItems: "center",
        ...webStyle({
            cursor: "pointer"
        })
    },
    dialogContentContainer: {
        alignItems: "stretch",
        width: "100%"
    },
    headerTitleContainer: {
        flexDirection: "row",
        alignItems: "center",
        flex: 1
    },
    lightboxCloseButton: {
        position: "absolute",
        zIndex: 10,
        right: 20,
        top: 20
    },
    headerActions: {
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap"
    },
    gridContainer: {
        flexDirection: "row",
        flexWrap: "wrap",
        width: "100%"
    },
    deleteButton: {
        position: "absolute",
        zIndex: 10
    },
    shareButton: {
        position: "absolute",
        zIndex: 10
    },
    itemTitle: {
        textAlign: "center",
        width: "100%"
    },
    modalBottomContainer: {
        width: "100%"
    },
    emptyText: {
        textAlign: "center"
    },
    contentContainer: {
        width: "100%",
        flex: 1
    },
    previewImage: {
        height: "100%",
        width: "100%"
    },
    scrollContainer: {
        width: "100%",
        flex: 1
    },
    lightboxImage: {
        height: "90%",
        width: "90%"
    },
    imagePreview: {
        height: 100,
        width: 100
    },
    itemWrapper: {

    }
});
export default stylesheet;
